import { isSSR } from "@sunrise/utils";
import { atom } from "jotai";

/**
 * The user-agent that the browser indicates.
 */
export const userAgentAtom = atom(
  isSSR() ? undefined : window.navigator.userAgent,
);
